import { Component, OnInit, Input, SimpleChanges, ViewChild, Output, EventEmitter, OnDestroy, Inject } from '@angular/core';
import { ReferenceArea } from '../../../reference-areas/models/reference-area';
import { TimetableEntry } from '../../models/timetable-entry';
import { TranslateService } from '@ngx-translate/core';
import { TimetableEditComponent } from '../timetable-edit/timetable-edit.component';

import * as FileSaver from 'file-saver';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-timetable',
  template: require('./timetable.component.html'),
  styles: [require('./timetable.component.sass')]
})
export class TimetableComponent implements OnInit, OnDestroy {

  @Input() scheduleDate: Date;
  @Input() timetable: TimetableEntry[];
  @Input() referenceAreas: ReferenceArea[];
  @Input() projectId: number;

  @Output() saveTimetableEntry = new EventEmitter<TimetableEntry>();
  @Output() deleteTimetableEntry = new EventEmitter<TimetableEntry>();

  @ViewChild(TimetableEditComponent) timetableEdit: TimetableEditComponent;


  tableConfiguration: any;
  columns: any[];
  languageChangeSubscription: Subscription;
  displayImportTimetable = false;
  inputTimetable = undefined;

  constructor(
    private translate: TranslateService,
    @Inject('TrainScheduleExportFactory') private trainScheduleExportFactory: any,
  ) {
    this.languageChangeSubscription = this.translate.onLangChange.subscribe(() => {
      this.refreshTimetable();
    })
   }

  ngOnInit(): void {
    this.tableConfiguration = {
      paginate: true,
      sortableMode: 'multiple',
      defaultPagination: 250,
      itemsPerPageOptions: [50,100,250,500],
      exportFilename: this.scheduleDate.getUTCDate + '_timetable_' + this.projectId
    }
    this.refreshTimetable()
  }

  refreshTimetable = () => {
    this.columns = [{
      header: this.translate.instant('I18N_SCHEDULING.SERVICE_ID'),
      field: 'serviceId',
      type: 'text'
    }, {
      header: this.translate.instant('I18N_SCHEDULING.START'),
      field: 'start',
      type: 'startService'
    }, {
      header: this.translate.instant('I18N_SCHEDULING.END'),
      field: 'end',
      type: 'endService'
    }, {
      header: this.translate.instant('I18N_SCHEDULING.FROM'),
      field: 'startStationAbbr',
      type: 'text'
    }, {
      header: this.translate.instant('I18N_SCHEDULING.TO'),
      field: 'endStationAbbr',
      type: 'text'
    },
    {
      header: this.translate.instant('I18N_SCHEDULING.ACTIONS'),
      disableSorting: true,
      disableSearch: true,
      width: '100px'
    }]
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.timetable = this.timetable && this.timetable.map(timetableEntry => {
      const startStation = this.referenceAreas && this.referenceAreas.find(station => station.id === timetableEntry.startStation);
      timetableEntry.startStationName = startStation && startStation.name;
      timetableEntry.startStationAbbr = startStation && startStation.abbreviation;
      const endStation = this.referenceAreas && this.referenceAreas.find(station => station.id === timetableEntry.endStation);
      timetableEntry.endStationName = endStation && endStation.name;
      timetableEntry.endStationAbbr = endStation && endStation.abbreviation;
      return timetableEntry;
    })

    if (this.tableConfiguration) {
      this.tableConfiguration.exportFilename = `${this.scheduleDate.getFullYear()}-${this.scheduleDate.getMonth() + 1}-${this.scheduleDate.getDate()}_timetable_${this.projectId} `
    }

    
  }
  onAddTimetableEntry = async() => {
    await this.timetableEdit.showModal()
  }

  onEditTimetableEntry = async (entry:  TimetableEntry) => {
    await this.timetableEdit.showModal(entry)
  }

  onDeleteTimetableEntry = (entry: TimetableEntry) => {
    this.deleteTimetableEntry.emit(entry);
  }

  onSave = (entry: TimetableEntry) => {
    this.saveTimetableEntry.emit(entry);
  }

  onExport = () => {

  }

  timetableUploader = (event) => {
    console.log(event)
  }

  processCsvTimetable = (fileList: FileList) => {
    let fileContent: string | ArrayBuffer | null;
    if (fileList && fileList[0]) {
      let file = fileList[0];
      let fileReader: FileReader = new FileReader();
      fileReader.onloadend = (x) => {
        fileContent = fileReader.result;
        console.log(fileContent)
        const timetablePromise = this.trainScheduleExportFactory.parseTimetableCsv(fileContent, this.referenceAreas);
        timetablePromise.then((data) => {
            console.log(data)
        }, (errorMsg) => {
            console.log(errorMsg);
        });
      }
      fileReader.readAsText(file);
    }
  }

  ngOnDestroy() {
    this.languageChangeSubscription.unsubscribe();
  }
}
